import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const ScheduleGlobalRoutes = defineRoute({
    home: {
        route: {
            path: "/schedule-global",
            component: () => loadView(import("./ScheduleGlobalHome.vue")),
        },
    },
});
